import {Link} from 'gatsby';
import {styled} from '@material-ui/core/styles';

// Wrapper around gatsby link with style
export const NavLink = styled(Link)(() => ({
    textDecoration: 'none',
    color: 'inherit',
}));
